import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"
import { NgbModule } from "@ng-bootstrap/ng-bootstrap"
import { InViewportModule } from "ng-in-viewport"

import { BrowsingRoutingModule } from "./browsing-routing.module"
import { BrowsingComponent } from "./browsing.component"
import { BrowsingHeaderComponent } from "./browsing-header/browsing-header.component"
import { SubjectsComponent } from "./subjects/subjects.component"
import { TopicsComponent } from "./topics/topics.component"
import { BreadcrumbsComponent } from "./browsing-header/breadcrumbs/breadcrumbs.component"
import { BrowsingResultsGroupComponent } from "./browsing-results-group/browsing-results-group.component"
import { SharedComponentsModule } from "../shared-components/shared-components.module"
import { NgSelectModule } from "@ng-select/ng-select"
import { FormsModule } from "@angular/forms"
import { FeaturedCollectionsComponent } from "./browsing-header/featured-collections/featured-collections.component"
import { SubjectsGuard } from "../guards/Subjects.guard"

@NgModule({
    declarations: [
        BrowsingComponent,
        BrowsingHeaderComponent,
        SubjectsComponent,
        TopicsComponent,
        BreadcrumbsComponent,
        BrowsingResultsGroupComponent,
        FeaturedCollectionsComponent,
    ],
    imports: [
        CommonModule,
        BrowsingRoutingModule,
        SharedComponentsModule,
        NgbModule,
        InViewportModule,
        NgSelectModule,
        FormsModule,
    ],
    providers: [SubjectsGuard],
    exports: [BrowsingResultsGroupComponent],
})
export class BrowsingModule {}
